export default __webpack_public_path__ + "static/media/edit.dc29e999.svg";